<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      Roadmap
      <div class="ml-auto">
        <i
          v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()"
          class="fa fa-window-minimize pl-1 pr-1"
          aria-hidden="true"
          @click="toggleHeaderMenu()"
        ></i>
        <i
          v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()"
          class="fa fa-window-maximize pl-1 pr-1"
          aria-hidden="true"
          @click="toggleHeaderMenu()"
        ></i>
      </div>
    </div>

    <saved-card-menu
      :entry-client-object="clientObject"
      :original-saved-cards="roadmapSavedCards"
      set-type="survey"
      view-type="menu"
    ></saved-card-menu>

    <div class="chart-app">
      <chart-criteria
        ref="chartCriteria"
        :include-show-competitor-expectations="true"
        :include-show-pricing-power="true"
        :use-chart-type-card="true"
        display-type-label="Views"
        showUseTTMAsStartDate="true"
        :show-display-type="true"
        :is-comparative="false"
        is-profile-page="true"
        fixed-display-type="value-roadmap"
        :display-type-options-override="roadmapViewOptions"
        :maximum-competitors="5"
        :content-list="pageContent"
        @reset-client-chart="resetClientChart"
      ></chart-criteria>

      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results
                  v-show="!generatingChart && displayChartCriteriaResults"
                  ref="chartCriteriaResults"
                  :criteria-results-list="criteriaResultsList"
                  :criteria-results-company-list="criteriaResultsCompanyList"
                ></chart-criteria-results>
              </div>
              <chart-display-skeleton v-show="generatingChart"/>
              <by-value-roadmap
                v-show="isByValueRoadmap && !generatingChart"
                :host-app="this"
                :chart-data="chartData"
                :content-list="pageContent"
                @set-value-roadmap-id="setValueMapDataId"
                @set-recommendations-data="handleRecommendationsData"
              ></by-value-roadmap>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart
        button-label="Save as Card"
        chart-title="Roadmap"
        :initial-client-chart="clientChart"
        @save="updateClientCharts"
        @closeModal="closeModal('save-chart-confirmation')"
      ></save-chart>
    </vue-modal>

    <road-map-initiatives
      ref="roadMapInitiativesForProfileTable"
      modal-name="road-map-initiatives-roadmap"
      :display-initiatives="false"
      :showCustomInitiative="false"
      addOrSaveInitiative="Save"
      :saveEnabled="false"
    />
    <explore-navigation-modal
      ref="exploreNavigationModal"
      modal-name="explore-navigation-modal"
      modal-id="explore-navigation-modal"
    />
  </div>
</template>

<script>
import AdminService from "../../services/admin.service";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import ValueGroupMap from "../../services/chart/value.group.map.service";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import ByValueRoadmap from "./type/ByValueRoadmap.vue";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import RoadMapInitiatives from "../../modals/RoadMapInitiatives.vue";
import ExploreNavigationModal from "../../modals/ExploreNavigationModal.vue";

export default {
  name: "Roadmap",
  mixins: [ChartCompanyMixins],
  components: {
    ByValueRoadmap,
    ChartDisplaySkeleton,
    SaveChart,
    RoadMapInitiatives,
    ExploreNavigationModal
  },
  data() {
    return {
      chartData: [],
      isByValueRoadmap: true,
      displayProfileStrengthLegend: false,
      selectedValueRoadMapId: 0,
      roadmapViewOptions: [
        { name: "Map", value: "value-roadmap" },
        { name: "Explore", value: "roadmap-explore", disabled: true },
        { name: "Predictive", value: "roadmap-predictive", disabled: true }
      ]
    };
  },
  computed: {
    roadmapSavedCards() {
      return this.clientChartsBySurvey.filter(card => card.chartTypeId == 29);
    }
  },
  created() {
    this.chart = ChartService.getChartAttributes("Roadmap");
  },
  methods: {
    closeModal(name) {
      if (this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    setValueMapDataId(valueRoadMapId) {
      this.selectedValueRoadMapId = valueRoadMapId;
      if (this.$refs.chartCriteria != null && this.$refs.chartCriteria.$refs.valueRoadMapSetupRef != null) {
        this.$refs.chartCriteria.$refs.valueRoadMapSetupRef.$data.valueRoadMapId = valueRoadMapId;
      }
    },
    displayChartCallback(response) {
      try {
        this.$root.processServerResponse();
        this.generatingChart = false;
        this.isByValueRoadmap = true;
        this.chartData = response.data;
      } catch (err) {
        ErrorService.processException("Roadmap.displayChartCallback", err, "chart", this);
      }
    },
    goToExploreForProfileTable(needType, needNumber) {
      this.$refs.exploreNavigationModal.$data.needType = needType;
      this.$refs.exploreNavigationModal.$data.needNumber = needNumber;
      this.$refs.exploreNavigationModal.$data.clientChartId = this.clientChart.clientChartId;
      this.$modal.show("explore-navigation-modal");
    },
    async displayInitiativesForProfileTable(element) {
      let needName = element.name;
      let needNumber = element.needNumber;
      let needType = element.needType;
      let valueRoadMapId = this.selectedValueRoadMapId;
      let moatDescription = element.moatDescription || { description: "", attributes: "{}" };
      let initiative = "";
      let description = "";
      let vm = this;

      await ValueGroupMap.getValueRoadMapInitiative(this.survey.surveyCode, needNumber, needType, valueRoadMapId, response => {
        if (response.data.statusCode == 200) {
          initiative = response.data.data.initiative;
          description = response.data.data.description;
          vm.selectedValueRoadMapId = response.data.data.valueRoadMapId;
        } else {
          AdminService.displayErrorMessage({ text: response.data.message });
        }
      }, this);

      let modal = this.$refs.roadMapInitiativesForProfileTable;
      modal.$data.selectedInitiative = { initiative: initiative, description: description };
      modal.$data.title = needName;
      modal.$data.moatName = element.moatName;
      modal.$data.needName = needName;
      modal.$data.needNumber = needNumber;
      modal.$data.needType = needType;
      modal.$data.valueRoadMapId = valueRoadMapId;
      modal.$data.sequenceNumber = element.sequenceNumber;
      modal.$data.initiatives = JSON.parse(JSON.stringify(element.initiativeSuggestions));
      modal.$data.moatInitiatives = JSON.parse(JSON.stringify(element.moatInitiatives));
      modal.$data.moatDescription = JSON.parse(JSON.stringify(moatDescription));
      modal.loadData();
      this.$modal.show("road-map-initiatives-roadmap");
    }
  }
};
</script>
